var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 13.75H36.25M3.75 15H36.25M8.75 23.75H18.75M8.75 27.5H13.75M7.5 32.5H32.5C34.5711 32.5 36.25 30.8211 36.25 28.75V11.25C36.25 9.17893 34.5711 7.5 32.5 7.5H7.5C5.42893 7.5 3.75 9.17893 3.75 11.25V28.75C3.75 30.8211 5.42893 32.5 7.5 32.5Z",
    stroke: "#232429",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.091ae34f5fd8a22ad6019ca9962d55a2.svg";
export { ForwardRef as ReactComponent };